import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { eliminarUndefined } from '../../../helpers';

import { useForm, useFormValidation } from '../../../hooks';
import { useTipo } from '../hooks/useTipo';
import { usePrueba } from '../hooks/usePrueba';
import { useDispositivo } from '../hooks/useDispositivo';
import { useSitio } from '../hooks/useSitio';
import { usePacientePruebaAlergiaEditar } from '../hooks/usePacientePruebaAlergiaEditar';

import { DateInput, Error, Forbidden, LightButton, Loader, MultiFileUpdate, MultiFormAlergenos, MultiFormArchivos, PrimaryButton, ReactSelectSingleInput, ReactSelectSingleKeyInput, TextAreaInput } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const PruebaAlergiaEditar = ({ id, pruebaData, cancelar }) => {

    const { permisos } = useSelector(state => state.auth);

    const { updatePruebaAlergiaMutation: { mutate: updatePruebaAlergia, isPending } } = usePacientePruebaAlergiaEditar(id);

    const [userAction, setUserAction] = useState(false);

    const [resetFields, setResetFields] = useState(moment().unix());

    const [tipoPruebaReset, setTipoPruebaReset] = useState(true);

    const [pruebaReset, setPruebaReset] = useState(true);

    const [positivaReset, setPositivaReset] = useState(true);

    const [dispositivoReset, setDispositivoReset] = useState(true);

    const [sitioReset, setSitioReset] = useState(true);

    const [alergenosReset, setAlergenosReset] = useState(true);

    let alergenosAux = [];
    if(typeof pruebaData.alergenos !== 'undefined' && pruebaData.alergenos.length > 0){
        pruebaData.alergenos.forEach(alergeno => {
            if(typeof alergeno._id !== 'undefined'){
                alergenosAux.push({
                    id: alergeno._id,
                    alergeno: alergeno._id,
                    resultados: alergeno.resultados,
                    nombre: alergeno.nombre
                });
            }else{
                alergenosAux.push({
                    id: moment().unix() + Math.random(),
                    alergeno: "||created||" + alergeno.nombre,
                    resultados: alergeno.resultados,
                    nombre: alergeno.nombre
                });
            }
        });
    }else{
        alergenosAux = [{id: moment().unix() + Math.random(), alergeno: '', resultados: ''}];
    }

    const { fecha, tipoPrueba, prueba, positiva, dispositivo, sitio, alergenos, comentarios, archivos, archivosPrevios, onInputChange, onMultipleInputChange, onResetForm } = useForm({ fecha: pruebaData.fecha, tipoPrueba: pruebaData.tipoPrueba, prueba: pruebaData.prueba, positiva: (pruebaData.positiva) ? 'true' : 'false', dispositivo: (typeof pruebaData.dispositivo !== 'undefined') ? pruebaData.dispositivo : '', sitio: (typeof pruebaData.sitio !== 'undefined') ? pruebaData.sitio : '', alergenos: alergenosAux, comentarios: pruebaData.comentarios, archivos: [{id: moment().unix(), archivo: null}], archivosPrevios: pruebaData.archivos });

    const { isFormValid: isFormStaticValid, formValidationStatus: formStaticValidationStatus, formFields: formStaticFields, startFormValidation: startFormStaticValidation, setFormFieldValidation: setFormStaticFieldValidation, onResetValidation: onStaticResetValidation } = useFormValidation([{field: 'fecha', default: true}, {field: 'positiva', default: true}, {field: 'comentarios', default: true}]);

    const { isFormValid: isFormTipoPruebaValid, formValidationStatus: formTipoPruebaValidationStatus, formFields: formTipoPruebaFields, startFormValidation: startFormTipoPruebaValidation, setFormFieldValidation: setFormTipoPruebaFieldValidation, onResetValidation: onTipoPruebaResetValidation } = useFormValidation([{field: 'tipoPrueba', default: true}]);

    const { isFormValid: isFormPruebaValid, formValidationStatus: formPruebaValidationStatus, formFields: formPruebaFields, startFormValidation: startFormPruebaValidation, setFormFieldValidation: setFormPruebaFieldValidation, onResetValidation: onPruebaResetValidation } = useFormValidation([{field: 'prueba', default: true}]);

    const { isFormValid: isFormNoStaticValid, formValidationStatus: formNoStaticValidationStatus, startFormValidation: startFormNoStaticValidation, setFormFieldValidation: setFormNoStaticFieldValidation, onResetValidation: onNoStaticResetValidation } = useFormValidation([{field: 'alergenos', default: true}]);

    const { tipoQuery: { isLoading, isError, data: tipos } } = useTipo();

    const { pruebaQuery: { data: pruebas, refetch: refetchPrueba } } = usePrueba(tipoPrueba);
    
    const { dispositivoQuery: { data: dispositivos, refetch: refetchDispositivo } } = useDispositivo(tipoPrueba);

    const { sitioQuery: { data: sitios, refetch: refetchSitio } } = useSitio(tipoPrueba, prueba);

    const handleResetTipoPrueba = () => {
        setTipoPruebaReset(false);
        setTimeout(() => {
            setTipoPruebaReset(true);
        }, 1);
    }

    const handleResetPrueba = () => {
        setPruebaReset(false);
        setTimeout(() => {
            setPruebaReset(true);
        }, 1);
    }

    const handleResetPositiva = () => {
        setPositivaReset(false);
        setTimeout(() => {
            setPositivaReset(true);
        }, 1);
    }

    const handleResetDispositivo = () => {
        setDispositivoReset(false);
        setTimeout(() => {
            setDispositivoReset(true);
        }, 1);
    }

    const handleResetSitio = () => {
        setSitioReset(false);
        setTimeout(() => {
            setSitioReset(true);
        }, 1);
    }

    const handleResetAlergenos = () => {
        setAlergenosReset(false);
        setTimeout(() => {
            setAlergenosReset(true);
        }, 1);
    }

    const handleClearForm = () => {
        onResetForm();
        onStaticResetValidation();
        onTipoPruebaResetValidation();
        onPruebaResetValidation();
        onNoStaticResetValidation();
        handleResetTipoPrueba();
        handleResetPrueba();
        handleResetPositiva();
        handleResetDispositivo();
        handleResetSitio();
        handleResetAlergenos();
        cancelar();
        setResetFields(moment().unix());
    }

    const handleOnFieldChange = (e) => {
        setUserAction(true);
        onInputChange(e);
    }

    useEffect(() => {
        if(userAction){
            refetchPrueba();
            refetchDispositivo();
            refetchSitio();
            let tipoStatus = false;
            if(typeof tipos !== 'undefined' && tipos.includes(tipoPrueba)){
                tipoStatus = true;
            }else if(tipoPrueba === ''){
                tipoStatus = null;
            }
            if(tipoPrueba === 'Reto'){
                onMultipleInputChange([{ target: { name: 'prueba', value: '' } }, { target: { name: 'dispositivo', value: 'Otro' } }, { target: { name: 'sitio', value: '' } }]);
            }else{
                onMultipleInputChange([{ target: { name: 'prueba', value: '' } }, { target: { name: 'dispositivo', value: '' } }, { target: { name: 'sitio', value: '' } }]);
            }
            setFormTipoPruebaFieldValidation('tipoPrueba', tipoStatus);
            setFormPruebaFieldValidation('prueba', null);
            handleResetPrueba();
            handleResetDispositivo();
            handleResetSitio();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tipoPrueba]);

    useEffect(() => {
        if(userAction){
            refetchSitio();
            let pruebaStatus = false;
            if(typeof pruebas !== 'undefined' && pruebas.includes(prueba)){
                pruebaStatus = true;
            }else if(tipoPrueba === ''){
                pruebaStatus = null;
            }
            if(tipoPrueba === 'Reto' && prueba === 'Alimentos'){
                onMultipleInputChange([{ target: { name: 'sitio', value: 'Oral' } }, { target: { name: 'alergenos', value: [{id: moment().unix(), alergeno: '', resultados: ''}] } }]);
            }else{
                onMultipleInputChange([{ target: { name: 'sitio', value: '' } }, { target: { name: 'alergenos', value: [{id: moment().unix(), alergeno: '', resultados: ''}] } }]);
            }
            setFormPruebaFieldValidation('prueba', pruebaStatus);
            setFormNoStaticFieldValidation('alergenos', true);
            handleResetSitio();
            handleResetAlergenos();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prueba]);
    
    const onSubmit = (e) => {
        e.preventDefault();

        let sitioStatus = true;
        if(typeof sitios !== 'undefined' && sitios.length > 0 && ![ '\u00A0', ...sitios ].includes(sitio) && sitio !== ''){
            sitioStatus = false;
        }

        let dispositivoStatus = true;
        if(typeof dispositivos !== 'undefined' && dispositivos.length > 0 && ![ '\u00A0', ...dispositivos ].includes(dispositivo) && dispositivo !== ''){
            dispositivoStatus = false;
        }

        if(formStaticValidationStatus === 'checked' && formTipoPruebaValidationStatus === 'checked' && formPruebaValidationStatus === 'checked' && formNoStaticValidationStatus === 'checked' && isFormStaticValid != null && isFormTipoPruebaValid != null && isFormPruebaValid != null && isFormNoStaticValid != null && isFormStaticValid && isFormTipoPruebaValid && isFormPruebaValid && isFormNoStaticValid && sitioStatus && dispositivoStatus){
            let alergenosAux = alergenos.filter(alerg => alerg.alergeno !== '').map(alerg => {
                if(alerg.alergeno.includes('||created||')){
                    return {
                        nombre: alerg.alergeno.replace('||created||', ''),
                        resultados: alerg.resultados
                    };
                }else{
                    return {
                        _id: alerg.alergeno,
                        resultados: alerg.resultados
                    };
                }
            });
            updatePruebaAlergia({ data: eliminarUndefined({ fecha, tipoPrueba, prueba, positiva, dispositivo: (dispositivos.includes(dispositivo)) ? dispositivo : '', sitio: (sitios.includes(sitio)) ? sitio : '', alergenos: JSON.stringify(alergenosAux), comentarios, archivos: archivos.filter(archivo => archivo.archivo !== null).map(archivo => archivo.archivo), archivosPrevios: JSON.stringify(archivosPrevios.map(archivo => archivo.id)) }, { sitio: undefined, dispositivo: undefined }), id: pruebaData._id, success:  handleClearForm});
        }else{
            startFormStaticValidation();
            startFormTipoPruebaValidation();
            startFormPruebaValidation();
            startFormNoStaticValidation();
        }
    }

    return (permisos.pruebaAlergiaCreate) ? (
        <>
            {(isLoading)
                ? <Loader />
                : <>
                    {(isError)
                        ? <Error />
                        : <>
                            <div className="row">
                                <div className="col">
                                    <div className={styles.estudioContainer}>
                                        <form onSubmit={onSubmit}>
                                            <div className="row">
                                                <div className="col">
                                                    <DateInput
                                                        formFieldStatus={ formStaticFields['fecha'].status }
                                                        label="Fecha"
                                                        name="fecha"
                                                        onChange={ handleOnFieldChange }
                                                        required={ true }
                                                        requiredIndicator={ true }
                                                        reset={resetFields}
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ fecha }
                                                    />
                                                </div>
                                            </div>
                                            {(tipoPruebaReset) && <div className="row">
                                                <div className="col">
                                                    <ReactSelectSingleInput
                                                        formFieldStatus={ formTipoPruebaFields['tipoPrueba'].status }
                                                        label="Tipo de prueba"
                                                        name="tipoPrueba"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        setFormFieldValidation={ setFormTipoPruebaFieldValidation }
                                                        value={tipoPrueba}
                                                        values={tipos}
                                                    />
                                                </div>
                                            </div> }
                                            <div className="row">
                                                {(pruebaReset && pruebas.length > 0) && <div className="col-md-12 col-lg-6">
                                                    <ReactSelectSingleInput
                                                        formFieldStatus={ formPruebaFields['prueba'].status }
                                                        label="Prueba"
                                                        name="prueba"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        setFormFieldValidation={ setFormPruebaFieldValidation }
                                                        value={prueba}
                                                        values={pruebas}
                                                    />
                                                </div> }
                                                {(positivaReset && pruebas.length > 0) && <div className="col-md-12 col-lg-6">
                                                    <ReactSelectSingleKeyInput
                                                        formFieldStatus={ formStaticFields['positiva'].status }
                                                        label="Resultados"
                                                        name="positiva"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={positiva}
                                                        values={[{ value: 'false', label: 'Negativas' }, { value: 'true', label: 'Positivas' }]}
                                                    />
                                                </div> }
                                            </div>
                                            <div className="row">
                                                {(dispositivoReset && dispositivos.length > 0) &&
                                                <div className="col-md-12 col-lg">
                                                    <ReactSelectSingleInput
                                                        formFieldStatus="checked"
                                                        label="Dispositivo"
                                                        name="dispositivo"
                                                        onChange={ handleOnFieldChange }
                                                        required={false}
                                                        requiredIndicator={false}
                                                        value={dispositivo}
                                                        values={[ '\u00A0', ...dispositivos ]}
                                                    />
                                                </div>
                                                }
                                                {(sitioReset && sitios.length > 0) &&
                                                <div className="col-md-12 col-lg">
                                                    <ReactSelectSingleInput
                                                        formFieldStatus="checked"
                                                        label="Sitio"
                                                        name="sitio"
                                                        onChange={ handleOnFieldChange }
                                                        required={false}
                                                        requiredIndicator={false}
                                                        value={sitio}
                                                        values={[ '\u00A0', ...sitios ]}
                                                    />
                                                </div>
                                                }
                                            </div>
                                            {(prueba !== '' && positiva === 'true' && alergenosReset) && <div className="row">
                                                <div className="col">
                                                    <MultiFormAlergenos
                                                        formsStatus="checked"
                                                        // formsStatus={ formNoStaticFields['alergenos'].status }
                                                        name="alergenos"
                                                        onFormsChange={ handleOnFieldChange }
                                                        prueba={prueba}
                                                        reset={resetFields}
                                                        setFormValidation={ () => {} }
                                                        // setFormValidation={ setFormNoStaticFieldValidation }
                                                        value={alergenos}
                                                    />
                                                </div>
                                            </div> }
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFormArchivos
                                                        formsStatus="checked"
                                                        name="archivos"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        value={archivos}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFileUpdate
                                                        name="archivosPrevios"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        value={archivosPrevios}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <TextAreaInput
                                                        formFieldStatus={ formStaticFields['comentarios'].status }
                                                        label="Comentarios"
                                                        name="comentarios"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ comentarios }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-lg-6">
                                                    <LightButton
                                                        block={true}
                                                        disabled={formStaticValidationStatus === 'checking' || formTipoPruebaValidationStatus === 'checking' || formPruebaValidationStatus === 'checking' || formNoStaticValidationStatus === 'checking' || isPending}
                                                        icon="X"
                                                        marginRight={true}
                                                        marginTop={false}
                                                        onClick={handleClearForm}
                                                        text="Cancelar"
                                                        type="button"
                                                    />
                                                </div>
                                                <div className="col-md-12 col-lg-6 mt-md-3 mt-lg-0">
                                                    <PrimaryButton
                                                        block={true}
                                                        disabled={formStaticValidationStatus === 'checking' || formTipoPruebaValidationStatus === 'checking' || formPruebaValidationStatus === 'checking' || formNoStaticValidationStatus === 'checking' || isPending}
                                                        icon="Check"
                                                        marginTop={false}
                                                        text="Guardar"
                                                        type="submit"
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </>
    ) : <div className='mt-2'><Forbidden /></div>
}

PruebaAlergiaEditar.propTypes = {
    id: PropTypes.string.isRequired,
    pruebaData: PropTypes.object.isRequired,
    cancelar: PropTypes.func.isRequired,
}